import {useEffect, useState} from 'react';

import {countActiveRangeFilters} from '../filterProcessor.util';
import {FilterOptionProps} from '../MyTeamsContent.types';

import {useMyTeamsContext} from './useMyTeamsContext';

type UseMyTeamsFilterCountProps = {
  currentFilters: {
    rankOptions?: FilterOptionProps[];
    newCoachesOptions?: FilterOptionProps[];
    fibcOptions?: FilterOptionProps[];
    bonusOptions?: FilterOptionProps[];
    frontlineOnly?: boolean;
    closeToNextRank?: boolean;
  };
  defaultNewCoachesValue: string;
  ffTeamsOrgSR: boolean;
};

export const useMyTeamsFilterCount = ({
  currentFilters,
  defaultNewCoachesValue,
  ffTeamsOrgSR,
}: UseMyTeamsFilterCountProps) => {
  const [filterCount, setFilterCount] = useState(0);
  const {filtersRedux} = useMyTeamsContext();
  const {
    rankOptions,
    newCoachesOptions,
    fibcOptions,
    bonusOptions,
    frontlineOnly,
    closeToNextRank,
  } = currentFilters;

  useEffect(() => {
    let totalLength: any[] = [];

    const rankFilter =
      rankOptions?.filter(f => f.id !== '' && f.selected) ?? [];
    const newCoachesFilter =
      newCoachesOptions?.filter(
        f => f.id !== defaultNewCoachesValue && f.selected,
      ) ?? [];
    const FIBCFilter =
      fibcOptions?.filter(f => f.id !== 'any' && f.selected) ?? [];
    const bonusFilter = bonusOptions?.filter(f => f.selected) ?? [];

    totalLength = [
      ...rankFilter,
      ...newCoachesFilter,
      ...FIBCFilter,
      ...bonusFilter,
    ];

    if (closeToNextRank) totalLength.push('closeToNextRank');

    const rangeFilters = countActiveRangeFilters(filtersRedux);
    totalLength.push(...rangeFilters);

    if (!ffTeamsOrgSR && frontlineOnly) totalLength.push('frontline');

    setFilterCount(totalLength.length);
  }, [
    rankOptions,
    newCoachesOptions,
    fibcOptions,
    bonusOptions,
    frontlineOnly,
    closeToNextRank,
    filtersRedux,
  ]);

  return filterCount;
};
